/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SoundboardIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACJElEQVR4nM1Uv2sUURDeEwvFShQVtb/eThRPhSB4+2Zmlbczq5GU/gP2J1oFJdjkX0hA+4Cm00QQLBIQtDoPJOYv8AcWicy7t3u7t+/OPWKRgS123rzv+2bezETRYTRAfg8oGwcGMiSbChZFUasAB9sGkn1DvHNgAkAeKFhM2eXch5g9dAQoq+XYOM5OA8prIF6cIQNe8mqXCh/KqvqUqAJOvK1+JWlMoMqHl3gwIuBvzge2XQMn3tb/xgRae30HQ/K2lNUrQFn7H+D/NEB+MxN4Z2HhmEF5ASi7BvmPXjTIT5Pk/sUgAfGi1ryxciB+PlRU/QzKT4P8uNPpHJ14F2zbdRjyikH+HpwTd+AeML3msknkpqs5yZ7vkA2iB6cC9z7UhCG/qwR1u/dO5ofW2uMVgDvpFUPy1df70xhJyxB/HKrmFZeF77CKxUl6qWCH9EZNpZGzgLKVq5tWrqDFmN0dpScvQzFJMn8GSPo+rjcjAT8q1XBPyxKMo+xq/vDdrr1Q2lkDnXi/VordVRgQL489VF/LEiIxJOs+5kmxXctdR7JZJ0BZq3eCbGlZxmMR01v5uXe1VLnbXbogxzvIq/oSmgEg6WtZyrFzc/Mn/NmPqIn1er0jgPxrAsG+T3tdlWsLI/J1n8FuIwJ9rGngMJF0tMan2m1rz80IvAMkz3Tao6bmltwI5Dcgfx4+PC9rC+uc6DDqxDcGrZHotIKcD/bxYbW/7+Z94sKc8jsAAAAASUVORK5CYII=)
 */
export const SoundboardIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.24 1.03a1 1 0 0 1 .73 1.21l-1 4a1 1 0 0 1-1.94-.48l1-4a1 1 0 0 1 1.21-.73ZM20.7 4.7a1 1 0 0 0-1.4-1.4l-4 4a1 1 0 0 0 1.4 1.4l4-4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15.14 20.14c1.78-1.78.7-5.75-2.42-8.86-3.11-3.12-7.08-4.2-8.86-2.42A3.13 3.13 0 0 0 3 11V11l-1.16 8.92a2 2 0 0 0 2.24 2.24L13 21c.86-.04 1.6-.32 2.14-.86Zm-1.3-3.4a9.61 9.61 0 0 0-2.53-4.05 9.61 9.61 0 0 0-4.05-2.53c-1.27-.35-1.82-.05-1.99.11-.16.17-.46.72-.11 2a9.61 9.61 0 0 0 2.53 4.04 9.61 9.61 0 0 0 4.05 2.53c1.27.35 1.82.05 1.99-.11.16-.17.46-.72.11-2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.05 3.32a1 1 0 0 1 1.9-.64l1 3a1 1 0 1 1-1.9.64l-1-3ZM22.97 9.76a1 1 0 0 0-1.21-.73l-4 1a1 1 0 1 0 .48 1.94l4-1a1 1 0 0 0 .73-1.21ZM20.68 16.95a1 1 0 0 0 .64-1.9l-3-1a1 1 0 0 0-.64 1.9l3 1Z"
        className={colorClass}
      />
    </svg>
  );
};
